module.exports = "<h2>Equality</h2><pre class=\"fragment\"><code class=\"lang-kotlin\">a == b    // Content equality -> a.equals(b)\na === b   // Instance equality</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-syntax/05.pug
// module id = 327
// module chunks = 1